import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ListaPacientes from '../components/Pacientes/ListaPacientes.vue'
import Paciente from '../components/Pacientes/Paciente.vue'
import store from '../store'

const routes = [
  {
    path: '/login',
    component: () => import('../components/Layouts/LoginLayout.vue'),
    children: [
      {
        path: '',
        name: 'login',
        component: () => import('../components/Pages/Login.vue'),
        meta: { requiresAuth: false }
      }
    ]
  },
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/dashboard',
    component: () => import('../components/Layouts/AuthLayout.vue'),
    meta: { requiresAuth: true },
    redirect: '/dashboard/admin/pacientes', 
    children: [
      {
        path: 'admin',
        name: 'adminDashboard',
        component: () => import('../components/Pages/DashboardAdmin.vue'),
        redirect: '/dashboard/admin/pacientes',
        children: [
          { 
            path: 'pacientes',
            name:'pacientes', 
            component: () => import('../components/Pacientes/ListaPacientes.vue') ,
            meta: { roles: ['Administrador', 'Supervisor', 'Analista',] }
          },
          { 
            path: 'personal',
            name:'personal', 
            component: () => import('../components/Personal/ListaPersonal.vue') ,
            meta: { roles: ['Administrador', ] }
          },
          { 
            path: 'consultas',
            name:'consultas', 
            component: () => import('../components/Consultas/ListaConsultas.vue') ,
            meta: { roles: ['Administrador', 'Supervisor'] }
          },
          { 
            path: 'agenda',
            name:'agenda', 
            component: () => import('../components/Agenda/Agenda.vue') ,
            meta: { roles: ['Administrador', 'Médico', 'Psicólogo', 'Fisioterapeuta'] }
          },
          {
            path: 'expediente',
            name:'expediente',
            component: () => import('../components/Expediente/ListaExpediente.vue') ,
            meta: { roles: ['Administrador', 'Supervisor', 'Médico', 'Analista', 'Psicólogo', 'Fisioterapeuta'] }
          },
          {
            path: 'consultorio-ai',
            name:'consultorio-ai',
            component: () => import('../components/ConsultorioAI/Expediente.vue') ,
            meta: { roles: ['Administrador'] }
          },
        ]
      }
    ]
  },
  {
    path: '/sin-permiso',
    name: 'sinPermiso',
    component: () => import('../components/Pages/SinPermiso.vue')
  },
  {
    path: '/:catchAll(.*)*',
    redirect: '/login'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {

  const isAuthenticated = store.getters.isAuthenticated
  const usuario = store.getters.getUsuario

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated || !usuario?.rol) {
      if (store.state.token || store.state.usuario) {
        store.dispatch('cerrarSesion')
      }
      if (to.name !== 'login') {
        return next('/login')
      }
      return next()
    }

    const rolesPermitidos = to.matched
      .filter(record => record.meta.roles)
      .flatMap(record => record.meta.roles)

    if (rolesPermitidos.length > 0 && !rolesPermitidos.includes(usuario.rol)) {
      return next('/sin-permiso')
    }
  }

  if (to.name === 'login' && isAuthenticated) {
    return next('/dashboard')
  }


  next()
})
export default router
